import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/es5/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  options: {
    customProperties: true,
  },
    global: {
        ripples: false
      },
    icons: {
        iconfont: 'mdi'
      },
      theme: {
        themes: {
          light: {
            primary: '#0E7AFF',
            primaryFade:"hsl(213, 100%, 96%)",
            // secondary: '#b0bec5', // this is not used or correct color.
            // anchor: '#0E7AFF', // this is not used or correct color.
            grey: "#999999",
            greyFade: "#eeeeee",
            accent:"#FFA427",
            accentFade: "#fff5e6",
            success: colors.teal.lighten1,
            successFade: colors.teal.lighten5,
            error: colors.red.accent3,
            errorFade: colors.red.lighten5,
            purple: "#8e62c2"
          },
          },
      }
});
